module.exports = __webpack_public_path__ + "img/civic-hatchback-22.5bdc37a7.png";